/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { NoticeCriteriaGroupActivity } from '../../../../../../../../../api/enumerations';
import { getDefaultCriterias } from '../../../../../../../../../api/theHive/criteriaGroups';
import {
  CriteriaData,
  DefaultCriteriasParams,
} from '../../../../../../../../../api/theHive/criteriaGroups/types';
import { GlobalContext } from '../../../../../../../../../context/global';
import useErrorMessage from '../../../../../../../../../hooks/useErrorMessage';

interface UseCriteriasProps {
  defaultCriterias: CriteriaData[];
  loadingCriterias: boolean;
  loadingError: boolean;
  getDefaultCriteriasCallback: () => Promise<void>;
}

export function useCriterias(
  activity: NoticeCriteriaGroupActivity
): UseCriteriasProps {
  const [defaultCriterias, setDefaultCriterias] = useState<CriteriaData[]>([]);
  const [loadingCriterias, setLoadingCriterias] = useState(false);
  const [loadingError, setLoadingError] = useState(false);

  const { setOpenSnackbar, setErrorMessage, setSnackbarMessage } =
    useContext(GlobalContext);
  const { getErrorMessage } = useErrorMessage();

  const { notice } = useParams();
  const noticeId = parseInt(notice as string, 10);

  const getDefaultCriteriasCallback = useCallback(async (): Promise<void> => {
    // sem conceito de espaço selecionado → sem critérios.
    if (!activity) {
      setDefaultCriterias([]);
      return;
    }
    try {
      setLoadingError(false);
      setLoadingCriterias(true);

      const params: DefaultCriteriasParams = {
        activity:
          activity === NoticeCriteriaGroupActivity.URBAN ? 'URBAN' : 'RURAL',
        noticeId,
      };
      const response = await getDefaultCriterias(params);

      if (response.detail.description) {
        throw new Error(response.detail.description);
      }
      if (response.detail.status_code !== 0) {
        throw new Error('Algo deu errado, tente novamente.');
      }

      setDefaultCriterias(response.data);
    } catch (error) {
      setSnackbarMessage(getErrorMessage(error));
      setOpenSnackbar(true);
      setErrorMessage(true);
      setLoadingError(true);
    } finally {
      setLoadingCriterias(false);
    }
  }, [activity, noticeId]);

  useEffect(() => {
    getDefaultCriteriasCallback();
  }, [getDefaultCriteriasCallback]);

  return {
    defaultCriterias,
    loadingCriterias,
    loadingError,
    getDefaultCriteriasCallback,
  };
}
